import React from 'react';

import LoaderWrap from './LoaderWrap';
import Loader from './index';

const LoaderFallback = () => (
  <LoaderWrap>
    <Loader size="48" />
  </LoaderWrap>
);

export default LoaderFallback;
